module.exports = __webpack_public_path__ + "assets/b25.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b25.png
// module id = 611
// module chunks = 0